import React, { Component } from 'react';
import ENV from '../../../../common/env.js';

class Map extends Component {
    shouldComponentUpdate(nextProps) {
        if (nextProps.refresh !== this.props.refresh) {
            return true;
        }
        return false;
    }

    render() {
        const { params, searchParams, source } = this.props;
        const { moduleType } = params;
        const { year, talUserId = '', leaderUserId = '' } = searchParams;
        console.log(searchParams);
        const srcUrl = `${ENV.MAP_URL}/lib/map_enrollment.html?date=${year}&moduleType=${moduleType}&talUserId=${talUserId}&leaderUserId=${leaderUserId}&source=${source}`;
        return (
            <div className="main map-iframe">
                <iframe src={srcUrl} height={500} width={'100%'} frameBorder={0} />
            </div>
        );
    }
}

export default Map;


// WEBPACK FOOTER //
// ./src/components/homePage/DimensionAnalysis/components/Map.js